require('./multiMap.js');



// WEBPACK FOOTER //
// ./node_modules/angular-ui-bootstrap/src/multiMap/index.js